import { useEffect, useState } from "react";
import { PackageCheck, Wrench } from "lucide-react";
import { api } from "@/lib/api";
import { fmtQty } from "@/lib/format";

export const PrepSummary = ({ woId }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/work-orders/${woId}/preparation-summary`).then((r) => setS(r.data)).catch(() => setS(null)); }, [woId]);
  if (!s || s.status === "no_requerida") return null;
  return (
    <div className="rounded-xl border border-border bg-card/40 p-4" data-testid="tech-prep-summary">
      <div className="mb-2 flex items-center gap-2 text-[11px] uppercase tracking-wider text-muted-foreground"><PackageCheck className="h-4 w-4" />Preparación · <span className="text-primary" data-testid="tech-prep-status">{s.status_label}</span></div>
      {s.items.length ? (
        <ul className="space-y-1 text-sm">
          {s.items.map((i, n) => <li key={n} className="flex items-center gap-2" data-testid={`tech-prep-item-${n}`}>{i.is_tool && <Wrench className="h-3.5 w-3.5 text-muted-foreground" />}{fmtQty(i.quantity)} {i.unit} · {i.description}</li>)}
        </ul>
      ) : <p className="text-sm text-muted-foreground">Aún no hay material preparado.</p>}
    </div>
  );
};
